<template>
    <popup :show="true" width="980px" @on-close="onClose">
            <div class="fabric-content-wrap">
                <div class="info-wrap">
                    <div class="left-popup">
                        <div v-if="current_temp_fabric.image_list.length > 0 || current_temp_fabric.video" class="slider">
                            <swiper ref="swiper" :options="swiperOption">
                                <swiper-slide v-if="current_temp_fabric.video">
                                    <video v-if="current_temp_fabric.video" :src="current_temp_fabric.video" muted autoplay controls id="video-material" >您的浏览器不支持视频播放。</video>
                                </swiper-slide>
                                <swiper-slide
                                        v-for="(item, index) in current_temp_fabric.image_list"
                                        :key="`sl` + index"
                                >
                                    <img v-viewer :src="item.url" class="img" />
                                </swiper-slide>
                                <!--                                    <div class="swiper-pagination" slot="pagination"></div>-->
                                <div slot="button-prev" class="swiper-button-prev"></div>
                                <div slot="button-next" class="swiper-button-next"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="right">
                        <p class="name">{{ current_temp_fabric.fabric_name_cn }}</p>
                        <p class="no">面料编号：{{ current_temp_fabric.fabric_key }}</p>
                        <p class="price">价格:¥{{ current_temp_fabric.fabric_price }}{{ current_temp_fabric.unit ? '/'+current_temp_fabric.unit:'' }}</p>
                        <div class="title" style="border-top: 1px solid #e0e0e0;margin-bottom:20px;">
                            <!-- 面料参数 -->
                        </div>
                        <div class="list">
                            <div class="item"><span class="key">单位：</span><span class="value">{{ current_temp_fabric.unit }}</span></div>
                            <div class="item"><span class="key">幅宽：</span><span class="value">{{ current_temp_fabric.width_wide }} CM</span></div>
                            <div class="item"><span class="key">克重：</span><span class="value">{{ current_temp_fabric.weight }}<template v-if="current_temp_fabric.unit_weight==2">G/M<sup>2</sup></template><template v-if="current_temp_fabric.unit_weight==1">G/M</template></span></div>
                            <div class="item"><span class="key">成分：</span><span class="value">{{ current_temp_fabric.component }}</span></div>
                            <div class="item"><span class="key">国标：</span><span class="value">{{ current_temp_fabric.standard }}</span></div>
                            <div class="item"><span class="key" style="">提供寄样服务：</span><span class="value">{{ current_temp_fabric.is_support_send_sample ? '是' :'否' }}</span></div>
                            <div class="color-title">颜色选择:</div>
                            <div class="color-box">
                                <div v-for="(item,index) in current_temp_fabric.color_list" :key="index" @click="choose_color(item)" :class="['color-item',{active:current_temp_fabric.color_name_cn === item.color_name_cn}]">
                                    <img v-viewer @click.stop :src="item.color_value|default_img" alt="" class="color-img" />{{ item.color_name_cn }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title-box">
                    <div class="title">产品详情</div>
                    <div class="line"></div>
                </div>
                <div class="richtext-wrap" v-html="current_temp_fabric.description"></div>
                <div class="btn-box">
                    <button class="cancel-btn" @click="onClose">取消</button>
                    <button class="confirm-btn" @click="onCreateDesign">创建款式设计</button>
                </div>
            </div>
        </popup>
</template>
<script> 
import Popup from "@/components/Popup.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default{
    components:{Popup,swiper,swiperSlide},
    name:"FabricDetail",
    props:{
        fabric:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
            current_temp_fabric:{
                image_list:[]
            },
            swiperOption: {
                loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
                autoplay: false,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                pagination: {
                el: ".swiper-pagination",
                clickable: true,
                },
                on: {
                slideChange: function () {
                    if (document.getElementById("video-material")) {
                    if (this.activeIndex === 0) {
                        document.getElementById("video-material").play();
                    } else {
                        document.getElementById("video-material").pause();
                    }
                    }
                },
                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            },
        }
    },
    mounted(){
        console.log('FabricDetail 接收到的 fabric 数据:', this.fabric);
        this.current_temp_fabric = Object.assign({}, this.fabric);
        console.log('FabricDetail current_temp_fabric:', this.current_temp_fabric);
    },
    methods:{
        onCreateDesign(){
            console.log('创建款式----，面料数据:', this.current_temp_fabric);
            console.log('面料数据的所有字段:', Object.keys(this.current_temp_fabric));
      
            // 保存面料数据到 localStorage，以便在设计页面使用
            localStorage.setItem('selected_fabric', JSON.stringify(this.current_temp_fabric));
            
            // 跳转到设计页面
            this.$router.push({ 
                name: 'WorkBenchDesign',
                params: {
                    file: {
                        type: '52' // 标识为面料类型
                    }
                }
            });
            
            // 关闭当前弹窗
            this.onClose();
        },
        onClose(){
            this.$emit('on-close')
        }
    }
}
</script>
<style lang="scss" scoped>
.fabric-content-wrap {
  margin-top: 40px;
  overflow-y: scroll;
  height: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 10px 0;
      height: auto;
    }
    .line {
      flex: 1;
      height: 1px;
      background: #ebebeb;
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-around;
    min-height: 430px;

    .left-popup {
      width: 420px;
      border: 1px solid #e5e5e5;
      .f-img {
        width: 420px;
        height: 420px;
      }
    }

    .right {
      // width: 500px;
      flex: 1;
      padding-right: 20px;
      padding-left: 20px;
      .name {
        color: #1a1a1a;
        font-size: 20px;
      }

      .no {
        color: #808080;
        font-size: 14px;
        margin-bottom: 20px;
        // margin: 25px 0;
      }
      .price {
        color: #e00000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 17px;
      }
      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          // width: 80px;
        }

        .value {
          color: #1a1a1a;
        }
      }
      .color-title {
        color: #1a1a1a;
        font-size: 16px;
        font-weight: bold;
      }
      .color-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 10px;
        margin-top: 26px;
        max-height: 200px;
        overflow-y: auto;
        .color-item {
          width: 112px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 6px;
          border-radius: 5px;
          border: 1px solid #e5e5e5;
          color: #4d4d4d;
          cursor: pointer;
          .color-img {
            width: 25px;
            height: 25px;
            border-radius: 5px;
          }
          &.active {
            border: 1px solid #fa3d5a;
            color: #fa3d5a;
          }
        }
      }
    }
  }

  .color-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 10px;
    // margin-top:26px;
    // max-height:200px;
    // overflow-y:auto;
    .color-item {
      width: 112px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 6px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      color: #4d4d4d;
      cursor: pointer;
      .color-img {
        width: 25px;
        height: 25px;
        border-radius: 5px;
      }
      &.active {
        border: 1px solid #fa3d5a;
        color: #fa3d5a;
      }
    }
  }

  .richtext-wrap {
    flex: 1;
    padding-bottom: 60px;
  }
  .btn-box {
    display: flex;
    justify-content: center;
    column-gap: 20px;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background: #ffffff;
    padding: 10px 0;
    .cancel-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      color: #1a1a1a;
      font-size: 14px;
      cursor: pointer;
    }
    .confirm-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #1a1a1a;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.slider {
  width: 420px;
  height: 420px;
  overflow: hidden;

  .swiper-slide {
    width: 420px;
    height: 420px;
  }

  .img,
  video {
    width: 420px;
    height: 420px;
    object-fit: contain;
  }
}

::v-deep .popup-modal {
  /* 核心容器 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);

  /* 弹窗内容区 */
  .popup-content {
    background: #fff;
    border-radius: 10px;
    //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
    min-height: 30vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}
</style>